<template>
<div>

  <el-row :gutter="20">

    <el-col :md="5" :lg="5">
      <el-input placeholder="用户手机号" v-model="params.mobile" clearable><el-button slot="append" icon="el-icon-search" @click="searchLog"></el-button></el-input>
    </el-col>
    <el-col :md="7" :lg="5">
          <el-select v-model="category_id" @change="searchLog" placeholder="选择活动"
                     style="width: 100%;" size="">
              <el-option
                      v-for="(item, index) in category"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
              </el-option>
          </el-select>
      </el-col>
    <el-col :md="7" :lg="2">
          <el-button @click="init" type="warning">重置</el-button>
    </el-col>
      <el-col :md="10" :lg="6">
          <el-date-picker v-model="create_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size=""></el-date-picker>
      </el-col>
    <el-button type="primary" @click="exportDataA"> 导出数据</el-button>

  </el-row>
      <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="报名信息" name="admin"></el-tab-pane>
      <el-table :data="list" :height="wheight-160" v-loading="loading">
        <el-table-column prop="ac_id" label="活动id"></el-table-column>
        <el-table-column prop="cosmo_name" label="奖品名称"></el-table-column>
        <!-- <el-table-column prop="ship_name" label="用户名"></el-table-column> -->
        <el-table-column prop="mobile" label="用户手机"></el-table-column>
        <!-- <el-table-column prop="address" label="用户地址"></el-table-column> -->
        <el-table-column prop="date_time" label="中奖时间">
          <template slot-scope="scope">
            {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="is_send" label="领取成功">
          <template slot-scope="scope">
            {{scope.row.is_send == 1 ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="err_msg" label="错误信息">
          <template slot-scope="scope">
            {{scope.row.err_msg}}
          </template>
        </el-table-column>
        <el-table-column prop="is_send" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="sendMsg(scope.row)" :disabled="scope.row.is_send == 1">补发</el-button>
            <!-- <el-button type="primary" size="mini" @click="sendMsg(scope.row)">补发</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div  class="content-padded content-center">
        <el-pagination background
                       layout="prev, pager, next, total"
                       @current-change="handleCurrentChange"
                       :current-page.sync="params.page"
                       :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
      </div>

</template>
<script>
    import { mapGetters } from 'vuex'
    import {getActivityLog,exportActivityLog,getActivityCategoryList,resendActivityMsg} from '../../../../api/marketing'

    export default {
        data () {
            return {
                clickable:false,
                dialog: false,
                activeName: 'admin',
                list: [],
                category_id:'',
                total_count: 0,
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    mobile:'',
                    ac_id:'',
                    time_start_begin:'',
                    time_start_end:'',
                },
                create_time:'',
                category:[],
                time_start_begin:'',
                time_start_end:'',
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {

            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
                this.getList()
            },
            searchLog () {
                this.params.page = 1
                this.params.ac_id = this.category_id
                this.getList()
            },
            dateChange (val) {
                if (val.length > 0) {
                    this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.time_start_begin = ''
                    this.time_start_end = ''
                }
                this.params.page = 1

                this.getList(this.params)
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            init () {
              this.params.ac_id = '',
              this.category_id = '',
              this.getList()
            },
            getList () {
                this.loading = true
                if(this.$route.query.activity_id) {
                    this.params.activity_id = this.$route.query.activity_id
                }
                this.params.time_start_begin = this.time_start_begin
                this.params.time_start_end = this.time_start_end
                getActivityLog(this.params).then(response => {
                    if(response.data.data.list) {
                        // console.log(response.data.data.list)
                        this.list = response.data.data.list
                        this.total_count = Number(response.data.data.total_count)

                    }
                    this.loading = false
                })
            },
            getAllCategory(){
              getActivityCategoryList().then(response=>{
                    this.category = response.data.data.list
                    console.log(this.category),'2222222222222';
                })
            },
            exportDataA(){
              // 导出数据
                exportActivityLog(this.params).then(response => {
                    //console.log(response.data)
                    if(response.data) {
                        var a = document.createElement('a')
                        a.href = response.data.url
                        a.download = response.data.filename
                        a.click()
                    }
                })
            },
            sendMsg(row) {
                this.$confirm('确定要重新发送中奖信息吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    resendActivityMsg({
                        id: row.id
                    }).then(response => {
                        this.loading = false
                        if (response.data.data.success === true) {
                            this.$message({
                                type: 'success',
                                message: response.data.message || response.data.msg || '重新发送成功'
                            })
                            // 刷新列表
                            this.getList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: response.data.message || response.data.msg || '重新发送失败'
                            })
                        }
                    }).catch(error => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络错误，请稍后重试'
                        })
                    })
                }).catch(() => {
                    // 取消操作
                })
            },
        },
        mounted () {
            this.getAllCategory()
            if (this.$route.query.ac_id) {
              this.params.page = 1
              this.params.ac_id = this.$route.query.ac_id
            }
            this.getList()
        }
    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// log.vue?19858247